import React from "react";
import { Row, Col } from "react-flexbox-grid/lib/index";
import PropTypes from "prop-types";
import ListIcon from "@material-ui/icons/List";

import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Typography
} from "@material-ui/core";
import SelectSearchable from "components/Select";
import UploadStepper from "./UploadStepper";

const UploadLayout = props => (
  <div>
    <Row>
      <Col xs={12}>
        <Card>
          <CardHeader
            title="Upload"
            action={
              <span>
                <Menu
                  anchorEl={props.optionsMenuAnchorEl}
                  open={Boolean(props.optionsMenuAnchorEl)}
                  onClose={props.handleOptionsMenuClose}
                >
                  <MenuItem
                    value="1"
                    onClick={() => {
                      props.handleOptionsMenuClose();
                      props.actions.downloadLog();
                    }}
                  >
                    Download log
                  </MenuItem>
                </Menu>
                <IconButton
                  onClick={props.handleOptionsMenuOpen}
                  style={{ marginTop: -9 }}
                >
                  <ListIcon />
                </IconButton>
              </span>
            }
            style={{ backgroundColor: "rgb(232, 232, 232)" }}
          />

          <CardContent>
            <Row>
              <Col xs={7}>
                <Typography>
                  Welcome to the upload page. Upload data from an excel file
                  into the database here.
                </Typography>
              </Col>
              <Col xs={3}>
                <SelectSearchable
                  onChange={props.onSelectedOrganizationChange}
                  options={props.allowedOrganizations}
                  value={props.selectedOrganization}
                  placeholder="Select one"
                  label="Organization"
                />
              </Col>
              <Col xs={2}>
                <Button
                  variant="contained"
                  onClick={() =>
                    window.open(
                      "https://drive.google.com/drive/folders/0BwSGouBGB1TXbDJLOXlKR3NSVXM"
                    )
                  }
                >
                  Templates
                </Button>
              </Col>
            </Row>
            <UploadStepper {...props} />
          </CardContent>
        </Card>
      </Col>
    </Row>
  </div>
);

UploadLayout.defaultProps = {
  optionsMenuAnchorEl: null,
  selectedOrganization: null
};
UploadLayout.propTypes = {
  handleOptionsMenuOpen: PropTypes.func.isRequired,
  handleOptionsMenuClose: PropTypes.func.isRequired,
  onSelectedOrganizationChange: PropTypes.func.isRequired,
  selectedOrganization: PropTypes.string,
  allowedOrganizations: PropTypes.arrayOf(PropTypes.string).isRequired,
  optionsMenuAnchorEl: PropTypes.node,
  actions: PropTypes.shape({ downloadLog: PropTypes.func }).isRequired
};

export default UploadLayout;
